import { localizedNeedLoginPath } from '~/utils/common'

export const noEnglishMenus = ['tool', '/invite', '/tool/bloggers']
export default defineNuxtPlugin(() => {
  const router = useRouter()
  const user = useUser()
  const localePath = useLocalePath()
  router.beforeEach((to, _, next) => {
    // 注册推广码 GLOBAL-357
    const { query, path } = to
    if (query.promotionCode) {
      const { setPromotionCodeData } = useRegistrationPromotionCode()
      setPromotionCodeData(query.promotionCode as string)
    }
    const pathFirst = path.split('/')[1]
    if (pathFirst === 'en') {
      const pathKey = path.split('/')[2]
      if (noEnglishMenus.includes(pathKey) || noEnglishMenus.includes(`/${pathKey}`)) {
        router.replace(localePath('/analysis/products'))
        return
      }
    }
    if (localizedNeedLoginPath().includes(to.path) && !user.value.info?.id) {
      router.replace(localePath('/analysis/products')).then(() => {
        nextTick(() => {
          location.reload()
        })
      })
    }
    else {
      next()
    }
  })
})
